import { Loader2 } from "lucide-react";

import { WhitelabelDashboardCard } from "./components/WhitelabelDashboardCard";
import { useEnterAccount } from "./shared/hooks/useEnterAccount";
import { useWhitelabelDashboard } from "./shared/hooks/useWhitelabelDashboard";

export function WhitelabelDashboardPage() {
  const { data, isLoading } = useWhitelabelDashboard();
  const enterAccount = useEnterAccount();

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className="size-8 animate-spin text-text-brand-secondary" />
      </div>
    );
  }

  const accounts = data?.accounts ?? [];

  return (
    <div className="flex flex-col gap-3xl p-4xl">
      <h1 className="text-2xl font-semibold text-text-primary">My Customers</h1>

      {accounts.length === 0 ? (
        <div className="rounded-lg border-2 border-dashed border-border-secondary p-2xl text-center text-text-tertiary">
          No accounts yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-lg sm:grid-cols-2 lg:grid-cols-3">
          {accounts.map((account) => (
            <WhitelabelDashboardCard
              account={account}
              key={account.projectId}
              onEnter={enterAccount}
            />
          ))}
        </div>
      )}
    </div>
  );
}
